/* eslint-disable import/extensions */
import tracking from '@titanio/tracking'
import { IdleQueue } from 'idlize/IdleQueue.mjs'

const loader = () => {
  const queue = new IdleQueue({
    ensureTasksRun: true,
  })

  queue.pushTask(() => {
    tracking.track()
  })
}

export default { loader }
